/** Behaviour for the CMS blocks that need it; unrelated pages are untouched. */
(() => {
  const initialise = root => {
    root.querySelectorAll('[data-cms-behaviour="accordion"] .mg-cms-accordion__header').forEach(button => {
      if (button.dataset.cmsReady) return;
      button.dataset.cmsReady = 'true';
      const panel = button.nextElementSibling;
      if (!panel) return;
      panel.hidden = true;
      button.addEventListener('click', () => {
        const expanded = button.getAttribute('aria-expanded') !== 'true';
        button.setAttribute('aria-expanded', String(expanded));
        panel.hidden = !expanded;
        const icon = button.querySelector('.mg-cms-accordion__icon');
        if (icon) icon.textContent = expanded ? '−' : '+';
      });
    });
  };
  initialise(document);
  document.addEventListener('shopify:section:load', event => initialise(event.target));
})();
